/**
 * A practitioner's cancellation terms, in plain words.
 *
 * Renders nothing unless the practitioner has deliberately saved a policy —
 * we never show terms that were only ever a system default, and the backend
 * won't enforce them either (a client cancelling on a practitioner with no
 * saved policy gets the session price back in full).
 */
export const CancellationTerms = ({ policy, tone = "light", compact = false }) => {
  if (!policy) return null;

  const full = Number(policy.full_refund_hours);
  const partial = Number(policy.partial_refund_hours);
  const pct = Number(policy.partial_refund_percent);
  if (!Number.isFinite(full) || !Number.isFinite(partial)) return null;

  const dark = tone === "dark";
  const showPartial = pct > 0 && partial < full;

  return (
    <div
      style={{
        marginTop: compact ? 10 : 16,
        padding: compact ? "10px 12px" : "14px 16px",
        borderRadius: 10,
        background: dark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.03)",
        border: `1px solid ${dark ? "rgba(255,255,255,0.14)" : "rgba(0,0,0,0.08)"}`,
        textAlign: "left",
      }}
      data-testid="cancellation-terms"
    >
      <p
        style={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: dark ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.45)",
          margin: "0 0 8px",
        }}
      >
        Cancellation terms
      </p>
      <ul
        style={{
          margin: 0,
          paddingLeft: 16,
          fontSize: 12.5,
          lineHeight: 1.75,
          color: dark ? "rgba(255,255,255,0.82)" : "rgba(0,0,0,0.7)",
        }}
      >
        <li>Cancel more than {full} hours ahead for a full refund of the session price.</li>
        {showPartial && (
          <li>Between {full} and {partial} hours ahead, {pct}% of the session price is refunded.</li>
        )}
        <li>Inside {partial} hours, the session price isn&apos;t refundable.</li>
        <li>The card processing fee isn&apos;t refundable — rescheduling is always free.</li>
      </ul>
    </div>
  );
};

export default CancellationTerms;
